import { isNullOrUndefined } from "../../../common/utils/object.utils";

export const weightedAverage = (data) => {
  const sum = data.reduce((acc, item) => {
    return acc + item.value * item.weight;
  }, 0);
  const weightSum = data.reduce((acc, item) => {
    return acc + item.weight;
  }, 0);
  return sum / weightSum;
}

export const createContainerAggregatedMetrics = (containerItems, roi_total_path, getValueByPath) => {
  const metricsForWeightedAverage = ['roi', 'xirr'];
  const metricPaths = {
    roi: roi_total_path,
    xirr: 'aggregatedMetricsData.xirr.total.actual',
  };

  const result = {};

  // Handle weighted average metrics
  metricsForWeightedAverage.forEach(metricName => {
    const metricPath = metricPaths[metricName];
    const itemsWithMetric = containerItems.filter(item => !isNullOrUndefined(getValueByPath(item, metricPath)));
    
    if (itemsWithMetric.length > 0) {
      const weightedAvg = weightedAverage(itemsWithMetric.map(item => ({ 
        value: getValueByPath(item, metricPath), 
        weight: item.contributionsUsdValue || item.usdValue 
      })));
      
      result[metricName] = {
        total: {
          actual: weightedAvg
        }
      };
    }
  });

  // Handle sum-based metrics
  const totalContributions = containerItems.reduce((acc, item) => {
    const contributions = getValueByPath(item, 'aggregatedMetricsData.contributions.total.actual') || 0;
    return acc + contributions;
  }, 0);
  
  const totalDistributions = containerItems.reduce((acc, item) => {
    const distributions = getValueByPath(item, 'aggregatedMetricsData.distributions.total.actual') || 0;
    return acc + distributions;
  }, 0);

  // Add sum-based metrics to result
  result.contributions = {
    total: {
      actual: totalContributions
    }
  };

  result.distributions = {
    total: {
      actual: totalDistributions
    }
  };

  return result;
}

export const getDeltaByEventTypes = (events, selectedEventTypes, inOrOutFlow = 'in') => {
  const inflowKeys = ['roc','rfc', 'ca'];
  const outflowKeys = ['ctr','oex', 'ca'];
  return events ? 
      Object.entries(events)
      .filter(([key,value]) => inOrOutFlow === 'in' ? inflowKeys.includes(key) : outflowKeys.includes(key))
      .reduce((accumulator, [key, value]) => {
          if (!selectedEventTypes.includes(key)) {
              accumulator += value;
          }
          return accumulator;
      }, 0) : 0;
};

export const getRelevantValueByEventTypes = (events, selectedEventTypes, inOrOutFlow = 'in') => {
  const inflowKeys = ['roc','rfc', 'ca'];
  const outflowKeys = ['ctr','oex', 'ca'];
  return events ? 
      Object.entries(events)
      .filter(([key,value]) => inOrOutFlow === 'in' ? inflowKeys.includes(key) : outflowKeys.includes(key))
      .reduce((accumulator, [key, value]) => {
          if (selectedEventTypes.includes(key)) {
              accumulator += value;
          }
          return accumulator;
      }, 0) * (inOrOutFlow === 'out' ? -1 : 1) : 0;
};